





























































































import Vue, { PropType } from "vue";
import { ProductDeliveryMethodInterface } from "@/model/components/ProductDeliveryMethodInterface.ts";
import { validationMixin } from "vuelidate";
import {
  DeliveryMethodStringInterface,
  DELIVERY_ADDRESS,
  DELIVERY_METHOD
} from "@/model/delivery";
import {
  timeDesignations,
  TimeDesignationInterface
} from "@/model/timeDesignation.ts";
import { deliveryTimeShow } from "@/model/views/display";

// validations
// eslint-disable-next-line
function required(this: any) {
  return !(
    this.deliveryAddress !== DELIVERY_ADDRESS.AT_THE_STORE &&
    this.deliveryMethod === ""
  );
}

export default Vue.extend({
  name: "ProductDeliveryMethod",

  mixins: [validationMixin],

  props: {
    productDeliveryMethod: {
      type: Object as PropType<ProductDeliveryMethodInterface>
    },
    deliveryAddress: {
      type: String
    }
  },

  validations: {
    deliveryMethod: { required: required }
  },

  computed: {
    deliveryMethod(): string {
      return this.productDeliveryMethod.deliveryMethod;
    },
    timeDesignation(): string {
      return this.productDeliveryMethod.timeDesignation;
    },
    siteUrl(): string {
      return process.env.VUE_APP_SITE_URL;
    },
    DELIVERY_METHOD(): DeliveryMethodStringInterface {
      return DELIVERY_METHOD;
    },
    timeDesignations(): TimeDesignationInterface[] {
      return timeDesignations;
    },
    isTimeDesignationShow(): boolean {
      return deliveryTimeShow(this.deliveryMethod);
    }
  },

  methods: {
    validation(): boolean {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    updateProductDeliveryMethod(value: string, label: string): void {
      this.validation();
      this.$emit(
        "updateProductDeliveryMethod",
        Object.assign({}, this.productDeliveryMethod, { [label]: value }),
        label
      );
    }
  }
});
